module.exports = __webpack_public_path__ + "img/BAU_Partners_10.0c68d2fb.jpg";